export default __webpack_public_path__ + "static/media/trampapo_02_20.2e42a661.jpg";